<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="homepage">
    <img :src="this.bgImage" alt="Long Image" class="long-image" ref="image" />
    <lottery-wheel :items="prizeArr" :itemWidth="150" :targetIndex='prizeIndex' :isUsed="dataInfo.used === 'Y'"
      :disabledBtn="isClick" @start="handleStart" @stop="handleStop" @finish="handleFinish">
      <template #item="{ item }">
        <div class="custom-item">
          <div :style="{'background-image': `url(${item.prizeImageUrl})`}" class="prize-icon" />
          <div class="prize-name">{{item.prizeCode}}</div>
        </div>
      </template>
    </lottery-wheel>

    <img class="motorcyclePic" src="../../assets/img/scroll/motor.gif" />
    <!-- <div class="slider-container">
    </div> -->

    <!-- 中奖名单轮播 -->
    <div class="winnerListTitle">Liste des gagnants</div>
    <div class="winnerList">
      <vue-seamless-scroll :data="winnerList" :class-option="options" class="seamless-wrap">
        <ul>
          <li class="winnerItem" v-for="(item,index) in winnerList" :key="index">
            <!-- <span class="avatar" /> -->
            <span class="name"> {{ item.name || '-' }} </span>
            <span class="name"> {{ item.mobile || '-' }} </span>
            <span class="prize"> {{ item.prizeName || '-'}} </span>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>

     <!-- 需要提交信息 -->
    <van-popup v-model="showInfoModal" :close-on-click-overlay="false">
      <div class="show-info-modal">
        <div class="fill-info">
          <div class="fill-ts"></div>
          <div class="fill-draw">
            <!-- <img :src="winInfo.prizeImageUrl" class="fill-img" /> -->
            <img src="../../assets/img/gift.gif" class="fill-img" />
            <div class="fill-text">Vous avez gagné</div>
            <!-- <div class="fill-text">
              {{ winInfo.points ? `${winInfo.points} points + ` : ''}} {{ winInfo[activeText.prizeName] }}
            </div> -->
          </div>
          <div>
            <div class="fill-field">
              <img src="../../assets/img/name.png" class="info-img" />
              <van-field v-model="userInfo.winnerName" size="24px" :placeholder="$t('name')" />
            </div>
            <div class="fill-field">
              <vue-country-code-selector :country-code="countryCode"
                @update:countryCode="upDateCode"></vue-country-code-selector>
              <van-field v-model="userInfo.winnerPhone" :placeholder="$t('phone')" />
            </div>
            <div class="fill-field">
              <img src="../../assets/img/email.png" class="info-img" />
              <van-field v-model="userInfo.winnerEmail" :placeholder="$t('email')" />
            </div>
            <img class="submit-info flex-center" src="../../assets/img/submit-bt.png" @click="submitInfo" />
          </div>
        </div>
        <!-- <img src="../../assets/img/close.png" class="close-img" @click="closeDialog" /> -->
      </div>
    </van-popup>

    <!-- 不需要提交信息 -->
    <van-popup v-model="showModal" :close-on-click-overlay="false">
      <div class="show-modal">
        <div class="fill-info">
          <img v-if="winInfo.prizeImageUrl" :src="winInfo.prizeImageUrl" class="prizeImage" />
          <div v-if="winInfo.prizeCode !== 'THANK'" class="thank-text">{{ winInfo[activeText.prizeName] }}</div>
          <div v-if="winInfo.points" class="thank-text">{{ winInfo.points ? `Prix ​​de participation:${winInfo.points}points` : ''}} </div>
          <!-- < v-if="winInfo.prizeCode === 'THANK'" class="thank-text"> -->
          <div v-else class="thank-text">
            <div>Désolé !!!</div>
            <div>Vous n’avez pas gagné ！</div>
          </div>
          <!-- <div v-if="winInfo.prizeFrenchName" class="thank-text">{{ winInfo.points ? `${winInfo.points} points + ` : ''}} {{ winInfo[activeText.prizeName] }}</div> -->
        </div>
        <div :class="['thank-bt', dataInfo.ad === 'N' ? 'ad-n' : '']">
          <div class="img-btn" @click="closeDialog">Bon</div>
          <div v-if="winInfo.ad === 'Y'" class="img-btn" @click="pointsRejouer">Rejouer</div>
        </div>
        <img src="../../assets/img/close.png" class="close-img" @click="closeDialog" />
      </div>
    </van-popup>

    <img v-if="showModal || showInfoModal" src="../../assets/img/whatsApp.png" class="whatsApp-img" @click="handleWhatsApp" />
    <div  v-if="showModal || showInfoModal" class="footer-tips">Après avoir soumis vos informations gagnantes, veuillez contacter le 92098888 ou WhatsApp pour réclamer votre prix</div>
  </div>
</template>

<script>
import LotteryWheel from '../../components/LotteryWheel.vue'
import validation from '../../utils/validation'
import VueCountryCodeSelector from 'vue-country-code-selector/src/index'
import general from '../../utils/general'

// rewardStatus 兑换状态 0-未兑换 1-已兑换 2-已发送

export default {
  components: { LotteryWheel, VueCountryCodeSelector },
  data () {
    return {
      countryCode: 223,
      bgImage: '',
      activityCode: '',
      activityId: '',
      prizeArr: [],
      winnerList: [],
      prizeIndex: -1,
      show: false,
      showThank: false,
      showThankPoints: false,
      longitude: '',
      latitude: '',
      langType: 'fr',
      dataInfo: {},
      isClick: true,
      userInfo: {
        winnerNo: '',
        rewardCode: '',
        prizeCode: '',
        prizeName: '',
        prizeFrenchName: '',
        winnerName: '',
        winnerPhone: '',
        winnerEmail: ''
      },
      rewardCode: '',
      winUrl: '',
      options: {
        step: 0.5, // 滚动速度
        limitMoveNum: 5, // 可见项数
        hoverStop: true, // 悬停暂停
        direction: 1, // 0向下 1向上
        autoPlay: true
      },
      submitPoint: false,
      info: {},
      winInfo: {}, // 中奖信息
      showModal: false, // 不需要提交用户信息
      showInfoModal: false // 需要提交用户信息
    }
  },
  computed: {
    activeText () {
      return validation.langText(this.langType)
    }
  },
  show () {
    this.submitPoint = false
  },
  async created () {
    this.rewardCode = this.$route.params.dynamicPart
    this.activityCode = this.$route.params.activityCode
    await this.getCJConfig()
    // await this.getPrizeList()
    await this.getIPLocation()
    await this.getWinnerList()
    await this.getCurrentLocation()
    await this.getInfoCode()
  },
  methods: {
    handleWhatsApp () {
      window.open(`https://wa.me/+22392098888?text=codes de tirage：${this.rewardCode}`)
    },
    // 获取抽奖配置
    async getCJConfig () {
      const that = this
      const d = JSON.parse(JSON.stringify({ code: this.rewardCode }))
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords
            d.latitude = latitude
            d.longitude = longitude
            const { data = {} } = await that.$api.game.getCJConfig(d)
            that.bgImage = data.bgImage
            that.activityCode = data.activityCode
            that.activityId = data.activityId
            that.getPrizeList(data.activityId)
          },
          async (error) => {
            console.error('获取位置失败:', error.message)
            const { data = {} } = await that.$api.game.getCJConfig(d)
            that.bgImage = data.bgImage
            that.activityCode = data.activityCode
            that.activityId = data.activityId
            that.getPrizeList(data.activityId)
          }
        )
      } else {
        console.log('当前浏览器不支持地理定位')
        const { data = {} } = await that.$api.game.getCJConfig(d)
        that.bgImage = data.bgImage
        that.activityCode = data.activityCode
        that.activityId = data.activityId
        that.getPrizeList(data.activityId)
      }
      // this.getPrizeList()
    },
    async getCurrentLocation () {
      if (!navigator.geolocation) {
        this.error = '当前浏览器不支持定位功能'
        return
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // eslint-disable-next-line no-debugger
          const { longitude, latitude } = position.coords
          this.latitude = latitude
          this.longitude = longitude
        },
        (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.log('用户拒绝对地理定位的请求。')
              break
            case error.POSITION_UNAVAILABLE:
              console.log('位置信息是不可用的。')
              break
            case error.TIMEOUT:
              console.log('请求用户地理位置的操作超时。')
              break
            case error.UNKNOWN_ERROR:
              console.log('未知错误。')
              break
          }
          this.getIPLocation()
        },
        // 配置项
        {
          enableHighAccuracy: true, // 高精度模式
          timeout: 10000, // 10秒超时
          maximumAge: 0 // 不使用缓存
        })
    },
    // 判断是否中奖
    async getInfoCode () {
      this.isClick = true
      const { data } = await this.$api.game.getInfoCode(this.rewardCode)
      if (data) {
        this.winInfo = data
        this.dataInfo = data
        this.info = data
        if (data.used === 'N' && !data.rewardCode) { // 未抽奖
          // this.showModal = true
        } else if (data.used === 'Y' && data.rewardCode) { // 已抽奖 且已经提交过用户信息 显示不需要提交信息的弹框
          this.showModal = true
        } else if (data.rewardCode && data.prizeCode === 'THANK' && !data.points) { //  已抽奖 谢谢惠顾 无积分 显示不需要提交信息的弹框
          this.showModal = true
        } else { // 未提交信息 但是有积分 或有中奖信息 都显示需要提交信息的弹框
          this.showInfoModal = true
        }

        if (data.used === 'Y') {
          if (data.rewardStatus === '0' && data.prizeCode !== 'THANK') {
            this.winUrl = data.prizeImageUrl
            this.userInfo = general.ObjForIn(this.userInfo, data)
            this.show = true
          } else {
            this.showThank = true
          }
        }
      }
      this.isClick = false
    },
    // 获取奖品列表
    async getPrizeList () {
      // const d = JSON.parse(JSON.stringify({ activityId: this.activityId }))
      const that = this
      const { data } = await this.$api.game.getPrizeListV2({
        activityId: that.activityId
      }) //  getActivityPrizeList
      this.prizeArr = data.list || []
    },
    // 获取中奖人员列表
    async getWinnerList () {
      const d = JSON.parse(JSON.stringify({}))
      const { data } = await this.$api.game.getWinnerList(d)
      this.winnerList = data && data.filter(item => item.name)
    },
    async getIPLocation () {
      try {
        const response = await fetch('https://ipapi.co/json/')
        const data = await response.json()
        const { longitude, latitude } = data
        this.latitude = latitude
        this.longitude = longitude
      } catch (error) {
        console.error('IP定位失败:', error)
        return { city: null, country: null }
      }
    },
    upDateCode (code) {
      this.countryCode = code
    },
    async handleStart () {
      await this.getInfoCode()
    },
    async handleStop (data1, resolve) {
      const d = JSON.parse(JSON.stringify({
        latitude: this.latitude,
        longitude: this.longitude,
        code: this.rewardCode,
        activityCode: this.activityCode,
        imei: localStorage.getItem('visitorId')
      }))
      this.$api.game.getPrizeRedemption(d).then(({ data }) => {
        if (typeof data === 'undefined') return
        this.winInfo = data
        if (data.prizeCode === 'THANK' && !data.points) { // 未中奖 且无积分
          this.showModal = true
        } else {
          this.showInfoModal = true
          this.prizeArr.forEach((item, index) => {
            if (item.prizeCode === data.prizeCode) {
              this.prizeIndex = index
              this.winInfo.prizeImageUrl = item.prizeImageUrl
            }
          })
        }

        this.dataInfo = data
        if (this.dataInfo?.prizeCode === 'THANK') {
          this.prizeIndex = 'THANK'
        } else {
          this.userInfo = general.ObjForIn(this.userInfo, this.dataInfo)
          this.prizeArr.forEach((item, index) => {
            if (item.prizeCode === this.dataInfo?.prizeCode) {
              this.prizeIndex = index
              this.winUrl = item.prizeImageUrl
            }
          })
        }
      }).then(() => {
        resolve()
      })
    },
    handleFinish () {
      if (this.dataInfo.prizeCode === 'THANK') {
        this.showThank = true
      } else {
        this.show = true
      }
    },
    // 去看广告
    linkAd () {
      this.$router.push({
        path: '/advertising',
        query: { code: this.dataInfo.newRewardCode, activityCode: this.activityCode }
      })
    },
    // 提交奖品信息
    async submitInfo () {
      const d = JSON.parse(JSON.stringify(this.userInfo))
      console.log('userInfo1', this.userInfo)
      if (!d.winnerPhone || !d.winnerName || !d.winnerEmail) {
        return this.$toast("Veuillez entrer les informations de l'utilisateur")
      }
      const n = `+${this.countryCode} ${d.winnerPhone}`
      d.winnerPhone = n
      d.activityCode = this.activityCode
      d.prizeCode = this.dataInfo.prizeCode
      d.rewardCode = this.dataInfo.rewardCode
      d.winnerNo = this.dataInfo.winnerNo
      d.imei = localStorage.getItem('visitorId')
      const { data } = await this.$api.game.submitInfo(d)
      if (data) {
        console.log('datadata', data, this.prizeArr)
        this.showInfoModal = false
        this.showModal = true
        this.winInfo = data
        this.prizeArr.forEach((item, index) => {
          if (item.prizeCode === data.prizeCode) {
            this.prizeIndex = index
            this.winInfo.prizeImageUrl = item.prizeImageUrl
          }
        })
      } else {
        this.showInfoModal = false
      }
    },
    // 弹窗开关
    closeDialog () {
      // this.show = false
      // this.showThank = false
      // this.showThankPoints = false
      this.showModal = false
      this.showInfoModal = false
    },
    pointsQuit () {
      this.showThankPoints = false
      if (this.submitPoint) {
        this.submitInfo()
      }
    },
    pointsRejouer () {
      if (this.submitPoint) {
        this.submitInfo()
      }
      this.linkAd()
    }
  }
}
</script>
<style scoped lang="scss">
 .homepage {
   width: 100vw;
    height: 100vh;
    display: block;
 }
  .long-image {
    width: 100vw;
    height: 100vh;
    display: block;
    transition: transform 0.3s ease-out;

  }
  .prize-icon {
    width: 200px;
    height: 200px;
    background-position: center;
    background-size: cover;
    margin: 0 auto;
  }

  .prize-name {
    width: 200px;
    height: 30px;
    line-height: 1;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis ;
    white-space: nowrap;
    margin-top: 10px;
    font-size: 24px;
    color: #666;
  }
    /* 容器样式 */
  .slider-container {
    width: 77%;
    overflow: hidden;
    position: relative;
    height: 200px; /* 根据实际需要调整 */
    position: absolute;
    top: 54%;
    left: 50%;
    transform: translateX(-50%);
  }
  .motorcyclePic {
    width: 500px;
    position: absolute;
    top: 43%;
    left: 26%;
    transform: scaleX(-1);
    // animation: slide 10s linear infinite;
  }

  // /* 图片滑动动画 */
  // .sliding-image {
  //   position: absolute;
  //   height: 100%;
  //   animation: slide 10s linear infinite;
  // }

  /* 关键帧动画 */
  @keyframes slide {
    0% {
      left: -100%;
    }
    100% {
      left: 100%;
    }
  }
  .winnerListTitle {
    position: absolute;
    top: 56%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 30px;
  }
  .winnerList {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
    width: 77%;
    height: 300px;
    border: 8px solid #ffffff;
    border-radius: 16px;
  }
  .seamless-wrap {
    height: 300px;
    overflow: hidden;
    .winnerItem {
      padding: 0 24px;
      box-sizing: border-box;
      line-height: 50px;
      font-size: 24px;
      color: #666;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        width: 25%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: nowrap;
        white-space: nowrap;
        padding-right: 24px;
      }
      .phone {
        width: 20%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: nowrap;
        white-space: nowrap;
        padding-right: 24px;
      }
      .prize {
        width: 55%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: nowrap;
        white-space: nowrap;
      }
    }
  }

    ::v-deep .van-popup {
    background: transparent;
  }

  .show-modal {
    position: relative;
    .fill-info {
      width: 386px;
      height: 176px;
      background-image: url('../../assets/img/thank.png'); /* 替换为你的图片路径 */
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      box-sizing: border-box;
      text-align: center;
      border-radius: 20px;
      color: #ffffff;
      font-size: 22px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .thank-text {
        word-break:normal;
        white-space: pre-wrap;
        padding: 0 24px;
      }
    }

    .close-img {
      width: 36px;
      height: 36px;
      position: absolute;
      top: 0;
      right: 0px;
      z-index: 9999;
    }

    .thank-bt {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      justify-content: center;
      margin-top: 25px;
      box-sizing: border-box;
      padding: 0 20px;

      .img-btn {
        width: 150px;
        height: 50px;
        background-image: url('../../assets/img/tank-bt.png'); /* 替换为你的图片路径 */
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
      }
    }

    .ad-n {
      justify-content: center;
    }
  }

  .show-info-modal{
    position: relative;
    .fill-info {
      padding-top: 1px;
      width: 356px;
      height: 384px;
      background-image: url('../../assets/img/dialog.png'); /* 替换为你的图片路径 */
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      box-sizing: border-box;
      text-align: center;
      position: relative;

      .fill-ts {
        width: 139px;
        height: 15px;
        margin: 14px auto 0;
        background-image: url('../../assets/img/ts.png'); /* 替换为你的图片路径 */
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }

      .fill-draw {
        background-image: url("../../assets/img/goods.png");
        background-size: 100%;
        background-position: center top;
        background-repeat: no-repeat;
        width: 220px;
        margin: 24px auto 12px;
        box-sizing: border-box;

        .fill-img {
          width: 72px;
          height: 72px;
          margin: 15px auto 4px;
        }

        .fill-text {
          flex: 1;
          font-size: 12px;
          color: #D51000;
          padding: 0px 12px 6px;
          word-break: break-all;
        }
      }

      .fill-field {
        width: 201px;
        height: 32px;
        margin: 0 auto 10px;
        border-radius: 12px;
        background: #ffffff;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 10px;

        .info-img {
          width: 10px;
          height: 10px;
        }
      }
      .fill-tips {
        color: #ffffff;
        font-size: 22px;
        margin-top: 24px;
        padding: 0 32px;
        box-sizing: border-box;
      }
    }

    .submit-info {
      // background-image: url("../../assets/img/submit-bt.png");
      // background-size: cover;
      // background-position: center;
      // background-repeat: no-repeat;
      // width: 488px;
      // height: 80px;
      width: 80%;
      height: auto;
      margin: 0 auto;
    }

    .close-img {
      width: 36px;
      height: 36px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .custom-item {
    text-align: center;
  }
  .prizeImage {
    display: block;
    width: 160px;
    height: 160px;
    margin: 0 auto 12px;
  }
  .whatsApp-img {
    position: fixed;
    right: 48px;
    bottom: 172px;
    width: 168px;
    height: 168px;
    z-index: 9999;
    border-radius: 168px;
  }
  .footer-tips {
    position: fixed;
    left: 0;
    bottom: 32px;
    width: 100%;
    z-index: 9999;
    color: #ffffff;
    text-align: center;
    white-space: pre-wrap;
    word-break: normal;
    font-size: 36px;
    padding: 0 24px;
    box-sizing: border-box;
  }
</style>
